<template>
  <div>
    <h1 class="page-header">Company Profiles</h1>
    <ts-card>
      <ts-card-wrapper>
        <form class="form-horizontal">
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12">
              <div class="form-group row m-b-15">
                <label class="col-md-5 col-form-label control-label"
                  >Company Name KH <span class="text-danger">*</span></label
                >
                <div class="col-md-7">
                  <input
                    v-model="model.company_name_kh"
                    type="text"
                    class="form-control kh-font"
                    :class="{ 'is-invalid': errors.has('company_name_kh') }"
                    placeholder="Company name kh"
                  />
                  <div class="invalid-feedback" v-if="errors.has('company_name_kh')">
                    {{ errors.first('company_name_kh') }}
                  </div>
                </div>
              </div>
              <div class="form-group row m-b-15">
                <label class="col-md-5 col-form-label control-label "
                  >Company Name EN <span class="text-danger">*</span>
                </label>
                <div class="col-md-7">
                  <input
                    v-model="model.company_name_en"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('company_name_en') }"
                    placeholder="Company name en"
                  />
                  <div class="invalid-feedback" v-if="errors.has('company_name_en')">
                    {{ errors.first('company_name_en') }}
                  </div>
                </div>
              </div>
              <div class="form-group row m-b-15">
                <label class="col-md-5 col-form-label control-label "
                  >Prefix Code <span class="text-danger">*</span>
                </label>
                <div class="col-md-7">
                  <input
                    v-model="model.prefix_code"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('prefix_code') }"
                    placeholder="Enter prefix code"
                  />
                  <div class="invalid-feedback" v-if="errors.has('prefix_code')">
                    {{ errors.first('prefix_code') }}
                  </div>
                </div>
              </div>
              <div class="row form-group m-b-15">
                <label class="col-md-5 col-form-label">Phone Number</label>
                <div class="col-md-7">
                  <input
                    v-model="model.company_phone"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('company_phone') }"
                    placeholder="Enter phone number"
                  />
                  <div class="invalid-feedback" v-if="errors.has('company_phone')">
                    {{ errors.first('company_phone') }}
                  </div>
                </div>
              </div>
              <div class="row form-group m-b-15">
                <label class="col-md-5 col-form-label">Email Address</label>
                <div class="col-md-7">
                  <input
                    v-model="model.company_email"
                    type="email"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('company_email') }"
                    placeholder="Enter Email address"
                  />
                  <div class="invalid-feedback" v-if="errors.has('company_email')">
                    {{ errors.first('company_email') }}
                  </div>
                </div>
              </div>
              <div class="row form-group m-b-15">
                <label class="col-md-5 col-form-label">Web Site</label>
                <div class="col-md-7">
                  <input
                    v-model="model.company_website"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('company_website') }"
                    placeholder="Enter company web site"
                  />
                  <div class="invalid-feedback" v-if="errors.has('company_website')">
                    {{ errors.first('company_website') }}
                  </div>
                </div>
              </div>
              <div class="row form-group m-b-15">
                <label class="col-md-5 col-form-label">Company Address</label>
                <div class="col-md-7">
                  <textarea
                    v-model.trim="model.company_address"
                    class="form-control"
                    rows="3"
                    placeholder="Enter company address"
                  ></textarea>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">
              <div id="img-frame" class="text-center">
                <label for="logo_file" id="label_logo_file">
                  <img :src="logo_file_src" alt="" />
                </label>
                <input type="file" id="logo_file" ref="logo_file" accept="image/*" @change="onFileSelected" />
              </div>
            </div>
          </div>
          <hr />
          <div class="row  pull-right">
            <div class="col-lg-12 form-group">
              <ts-button color="primary" :disabled="saving" :waiting="saving" @click="onSave">
                Save
              </ts-button>
              <ts-button class="ml-2" @click="$router.push({ name: 'company' })">
                Cancel
              </ts-button>
            </div>
          </div>
        </form>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'

export default {
  name: 'company-create-form',
  data() {
    return {
      model: {
        company_name_kh: '',
        company_name_en: '',
        company_address: '',
        company_phone: '',
        company_email: '',
        company_website: '',
        company_logo: '',
        prefix_code: ''
      },
      file: '',
      errors: new Errors(),
      saving: false,
      logo_file_src: 'http://www.cgmsurgelati.it/wp-content/uploads/2017/09/loading.png'
    }
  },
  created() {},
  computed: {},
  methods: {
    async onSave() {
      this.errors = new Errors()
      this.saving = true
      let file_upload_path = await this.uploadLogo()
      this.$store
        .dispatch(
          'administration/company/onSaveCompanyProfile',
          Object.assign({}, this.model, { company_logo: file_upload_path })
        )
        .then(response => {
          this.saving = false
          this.clearForm()
          this.$toasted.success(response.message)
          this.$router.push({ name: 'company' })
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.saving = false
        })
    },

    uploadLogo() {
      this.file = this.$refs.logo_file.files[0] ? this.$refs.logo_file.files[0] : null
      if (this.file) {
        let formData = new FormData()
        formData.append('companyPhoto', this.file)
        return this.$store.dispatch('administration/company/onUploadCompanyLogo', formData)
      }

      return ''
    },

    onFileSelected() {
      const file = this.$refs.logo_file.files[0]
      let reader = new FileReader()
      reader.addEventListener(
        'load',
        function() {
          this.logo_file_src = reader.result
        }.bind(this),
        false
      )
      if (file) {
        if (/\.(jpe?g|png|gif)$/i.test(file.name)) {
          reader.readAsDataURL(file)
        } else {
          this.logo_file_src = 'http://www.cgmsurgelati.it/wp-content/uploads/2017/09/loading.png'

          this.$toasted.error('invalid file type!')
          this.$refs.logo_file.value = ''
        }
      }
    },
    clearForm() {
      this.model.company_name_kh = ''
      this.model.company_name_en = ''
      this.model.company_address = ''
      this.model.company_phone = ''
      this.model.company_email = ''
      this.model.company_website = ''
      this.model.company_logo = ''
      this.model.prefix_code = ''
      this.logo_file_src = 'http://www.cgmsurgelati.it/wp-content/uploads/2017/09/loading.png'
      this.$refs.logo_file.value = ''
    }
  },

  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('administration/company/RESET_STATE')
    }
    next()
  }
}
</script>

<style>
#logo_file {
  display: none;
}
#img-frame img {
  object-fit: contain;
  width: 310px;
  height: 308px;
  /* box-shadow: 0 4px 6px rgba(0, 0, 0, .1); */
}
#label_logo_file {
  cursor: pointer;
}
</style>
